//Javascript for the WECAN Admin Report
app.DistrictBilling = (
    function () {
        var districtBilling = {
            DistrictStatusUpdate: function () {
                $(document).on("change", "input[name*='DistrictStatusCheckbox']",
                    function (e) {
                        var id = $(e.target).attr("name").split(".")[0].replace("[", "").replace("]", "");
                        var active = $(e.target).prop("checked");

                        // now we have the id, so call the function to update the district's status
                        var form = $("#__AjaxAntiForgeryForm");
                        var token = $('input[name="__RequestVerificationToken"]', form).val();
                        $.ajax({
                            type: "POST",
                            data: { id: id, active: active, __RequestVerificationToken: token },
                            url: "/Admin/DistrictBilling/UpdateDistrictStatus",
                            success: function (data) {
                                if (data) {
                                    toastr.success("You have successfully updated the district status for " + data.districtName + " to " + data.districtStatus + ".");
                                } else {
                                    toastr.error(
                                        "Something went wrong, please try again. If the problem persist please contact support.");
                                }
                            },
                            error: function () {
                                toastr.error("Something went wrong.");
                            }
                        });
                    });
            }
        };

        return districtBilling;
    }()
);